import { render, staticRenderFns } from "./MesombTransactionDetail.vue?vue&type=template&id=240faa33&scoped=true"
import script from "./MesombTransactionDetail.vue?vue&type=script&lang=js"
export * from "./MesombTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./MesombTransactionDetail.vue?vue&type=style&index=0&id=240faa33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240faa33",
  null
  
)

export default component.exports